import { NetworkStatus } from "@apollo/client";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";

import { GET_STACKS_REQUIRING_ATTENTION } from "./gql";

const useStacksRequiringAttention = () => {
  const { data, loading, error, refetch, networkStatus } = usePolledQuery(
    GET_STACKS_REQUIRING_ATTENTION,
    {
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  const migration = data?.metrics?.stacksRequiringAttention?.stackTerragruntMigration;

  const isLoading = (loading && !data) || networkStatus === NetworkStatus.refetch;

  const readyToMigrate = migration?.readyToMigrate ?? 0;
  const migrated = migration?.migrated ?? 0;
  const isEmpty = !isLoading && !error && (!migration || (readyToMigrate === 0 && migrated === 0));

  return {
    readyToMigrate,
    migrated,
    isLoading,
    isEmpty,
    error,
    refetch,
  };
};

export default useStacksRequiringAttention;
